/*
  Woof&Meow path quiz UI. Renders the prototype's own markup (copied into <template data-tpl> by
  tools/path-quiz/build_section.py) from the core view model, the way the Claude Design runtime does:
  {{holes}}, <sc-if>, <sc-for>, onClick / onChange / ref. Updates the page in place (morph), so the
  3D canvas and a focused input survive every render.
*/
(function () {
  'use strict';
  const HOLE = /\{\{\s*([^}]+?)\s*\}\}/g;

  function lookup(scope, path) {
    const p = path.trim();
    if (p === 'true') return true;
    if (p === 'false') return false;
    if (/^-?\d+(\.\d+)?$/.test(p)) return Number(p);
    return p.split('.').reduce((o, k) => (o == null ? undefined : o[k]), scope);
  }
  function whole(attr) { const m = /^\s*\{\{\s*([^}]+?)\s*\}\}\s*$/.exec(attr); return m ? m[1] : null; }
  function interpolate(str, scope) {
    return str.replace(HOLE, (_, p) => { const v = lookup(scope, p); return v == null ? '' : String(v); });
  }

  // Build real DOM nodes from a template node. Event handlers and refs ride on the node as _wm.
  function build(tpl, scope, refs) {
    if (tpl.nodeType === 3) return [document.createTextNode(interpolate(tpl.data, scope))];
    if (tpl.nodeType !== 1) return [];
    const tag = tpl.tagName.toLowerCase();
    if (tag === 'helmet' || tag === 'script') return [];
    if (tag === 'sc-if') {
      return lookup(scope, whole(tpl.getAttribute('value')) || '') ? children(tpl, scope, refs) : [];
    }
    if (tag === 'sc-for') {
      const list = lookup(scope, whole(tpl.getAttribute('list')) || '') || [];
      const as = tpl.getAttribute('as');
      const out = [];
      list.forEach((item, i) => { const s = Object.create(scope); s[as] = item; s.$index = i; out.push(...children(tpl, s, refs)); });
      return out;
    }
    const isSvg = tpl.namespaceURI === 'http://www.w3.org/2000/svg';
    const el = isSvg ? document.createElementNS(tpl.namespaceURI, tpl.tagName) : document.createElement(tag);
    const wm = {};
    Array.from(tpl.attributes).forEach((a) => {
      const name = a.name.toLowerCase();
      if (name.startsWith('hint-')) return;
      const w = whole(a.value);
      if (name === 'onclick' && w) { wm.click = lookup(scope, w); return; }
      if (name === 'onchange' && w) { wm.input = lookup(scope, w); return; }
      if (name === 'ref' && w) { const fn = lookup(scope, w); if (typeof fn === 'function') refs.push([el, fn]); return; }
      el.setAttribute(a.name, interpolate(a.value, scope));
    });
    el._wm = wm;
    const kids = tpl.content ? tpl.content.childNodes : tpl.childNodes;
    Array.from(kids).forEach((c) => build(c, scope, refs).forEach((n) => el.appendChild(n)));
    if (tag === 'input') el.value = el.getAttribute('value') || '';
    return [el];
  }
  function children(tpl, scope, refs) {
    const out = [];
    Array.from(tpl.childNodes).forEach((c) => out.push(...build(c, scope, refs)));
    return out;
  }

  // Morph `from` (live) to match `to` (fresh build). Same tag at the same position is kept and patched.
  function morph(from, to) {
    if (from.nodeType === 3 && to.nodeType === 3) { if (from.data !== to.data) from.data = to.data; return from; }
    if (from.nodeType !== to.nodeType || from.nodeName !== to.nodeName) { from.replaceWith(to); return to; }
    // A canvas's width/height are its drawing size, set by the 3D renderer: resetting them to the
    // template's values would wipe the picture and stretch a 366x318 drawing over the room.
    const keep = from.tagName === 'CANVAS' ? ['width', 'height'] : [];
    Array.from(from.attributes).forEach((a) => { if (!to.hasAttribute(a.name) && !keep.includes(a.name)) from.removeAttribute(a.name); });
    Array.from(to.attributes).forEach((a) => { if (!keep.includes(a.name) && from.getAttribute(a.name) !== a.value) from.setAttribute(a.name, a.value); });
    from._wm = to._wm;
    if (from.tagName === 'INPUT' && from.value !== to.value) from.value = to.value;
    if (from.tagName === 'CANVAS') return from;
    // The bundle step's slot holds the product page buy box, which draws itself: leave its insides alone.
    if (from.hasAttribute('data-wm-buybox-slot')) return from;
    morphChildren(from, Array.from(to.childNodes));
    return from;
  }
  function morphChildren(parent, next) {
    const cur = Array.from(parent.childNodes);
    next.forEach((n, i) => { if (i < cur.length) morph(cur[i], n); else parent.appendChild(n); });
    for (let i = cur.length - 1; i >= next.length; i--) parent.removeChild(cur[i]);
  }

  // ---- store wiring: analytics, email signup, add to cart ----
  function track(name, data) {
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('wm_' + name, data || {}); } catch (e) { /* never block the quiz */ }
    try { if (typeof window.clarity === 'function') window.clarity('event', name + (data && data.step != null ? '_' + data.step : '')); } catch (e) { /* ignore */ }
  }
  // The email goes in the background so the shopper never waits or reloads (Shopify's hCaptcha on
  // contact forms is off, Mkeo 25 Oct 2026). If Shopify refuses it, for example because that protection
  // is switched back on, the section's real customer form takes over: Shopify binds its captcha to it,
  // and the quiz state is saved, so the shopper comes back to the same step after the reload.
  function submitEmail(s) {
    const tags = ['path-quiz'].concat((s.goals || []).map((g) => 'pq-goal-' + g), (s.matters || []).map((m) => 'pq-matters-' + m));
    const email = (s.email || '').trim();
    track('quiz_unlock', {});
    const body = new URLSearchParams();
    body.set('form_type', 'customer'); body.set('utf8', '✓');
    body.set('contact[email]', email); body.set('contact[tags]', tags.join(','));
    return fetch('/contact', { method: 'POST', body: body.toString(), headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
      .then((r) => (r.ok && /customer_posted=true/.test(r.url || '') ? 'ok' : 'refused'))
      .catch(() => 'offline')
      .then((result) => {
        signupResult(result);
        // Only a refusal from Shopify goes to the protected form; with no connection the form would
        // land on the browser's offline page, so the shopper stays in the quiz.
        if (result === 'refused') fallbackSignup(email, tags);
      });
  }
  function fallbackSignup(email, tags) {
    const form = document.querySelector('form[data-wm-quiz-signup]');
    if (!form) return;
    form.elements['contact[email]'].value = email;
    form.elements['contact[tags]'].value = tags.join(',');
    const go = () => { try { form.requestSubmit(); } catch (e) { form.submit(); } };
    const captcha = window.Shopify && window.Shopify.captcha;
    if (form.dataset.hcaptchaBound || !captcha || !captcha.protect) go(); else captcha.protect(form, go);
  }
  function signupResult(kind) {
    track(kind === 'ok' ? 'quiz_email_ok' : 'quiz_email_failed', { status: kind });
  }
  // The product page buy box on the bundle step (snippets/wm-quiz-buybox.liquid, Jake and Mkeo 26 Oct 2026).
  // Without it (snippet missing or its script failed) the quiz keeps its own bundle cards.
  function boxOn(config) { return config.buybox && window.WMQBox ? window.WMQBox : null; }
  const NAMES = { lgrey: 'Light Grey', dgrey: 'Dark Grey', navy: 'Dark Blue', khaki: 'Khaki', offwhite: 'Off-White', brown: 'Brown', black: 'Black' };
  function soldOutNote(s, tiles, config) {
    const colors = (s.pattern === 'solid' || s.mix.length < 2) ? [s.mix[0]] : [s.mix[0], s.mix[1]];
    const avail = colors.map((c) => { const v = (config.variants || []).find((x) => x.color === NAMES[c]); return !!(v && v.available); });
    if (avail.every(Boolean)) return '';
    if (!avail.some(Boolean)) return 'Those colors are sold out right now. Pick other colors.';
    const out = colors[avail.indexOf(false)], keep = colors[avail.indexOf(true)];
    return NAMES[out] + ' is sold out, so all ' + tiles + ' tiles come in ' + NAMES[keep] + '.';
  }
  function storeHook(view, store, config) {
    const s = store.state;
    const unlock = view.unlock;
    view.unlock = () => { const was = store.state.unlocked; unlock(); if (!was && store.state.unlocked) submitEmail(store.state); };
    if (s.step === 15) {
      const box = boxOn(config);
      let note = '';
      if (box) {
        const n = box.total(), left = box.want() - n;
        view.showCards = false;
        view.showBox = true;
        view.hasSpares = view.spares > 0 && n === view.rec;
        view.ctaLabel = left > 0 ? 'Pick ' + left + ' more ' + (left === 1 ? 'tile' : 'tiles')
          : (view.possLower === 'your' ? 'Add ' : 'Add ' + view.possLower + ' ') + n + ' tiles to cart';
      } else note = soldOutNote(s, view.chosen, config);
      if (s.cartBusy) view.ctaLabel = 'Adding...';
      if (s.cartError) view.ctaFoot = s.cartError;
      else if (note) view.ctaFoot = note;
    }
  }
  async function addToCart(store, config) {
    const s = store.state;
    if (s.cartBusy) return;
    const view = store.view();
    const box = s.step === 15 ? boxOn(config) : null;
    let tiles, items;
    if (box) {
      tiles = box.total();
      // Only the exact amount the selected card prices goes to the cart (review 26 Oct 2026: never more or less).
      if (tiles < 1 || tiles !== box.want()) return;
      items = box.items() || [];
    } else {
      tiles = view.chosen;
      items = window.WMQuiz.cartLines(tiles, s.mix, s.pattern, config.variants);
      if (!items.length) { store.setState({ cartError: 'Those colors are sold out right now. Pick other colors.' }); return; }
    }
    if (box) box.setBusy(true);
    store.setState({ cartBusy: true, cartError: '' });
    try {
      const add = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!add.ok) throw new Error('add ' + add.status);
      // The quiz answers on the cart are a nice-to-have: the tiles are in, so a failure here never
      // shows an error (a retry would add the tiles twice).
      try {
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { quiz: 'path-finder', quiz_goals: (s.goals || []).join(','), quiz_spots: (s.spots || []).join(','), quiz_bundle: String(tiles), quiz_rec: String(view.rec) } }) });
      } catch (e) { /* ignore */ }
      track('quiz_add_to_cart', { tiles, rec: view.rec });
      // cartBusy stays on while the browser goes to the cart, so a second tap cannot add again;
      // the pageshow handler clears it if the shopper comes back with the back button.
      window.WMQuiz.navigate(s.unlocked ? '/discount/' + encodeURIComponent(config.discountCode || 'WELCOME10') + '?redirect=/cart' : '/cart');
    } catch (e) {
      if (box) box.setBusy(false);
      store.setState({ cartBusy: false, cartError: 'Could not add to cart. Please try again.' });
    }
  }

  function mount(host) {
    const page = host.closest('[data-wm-quiz]');
    const config = JSON.parse(page.querySelector('[data-wm-quiz-config]').textContent);
    const tpls = { mobile: page.querySelector('template[data-tpl="mobile"]'), desktop: page.querySelector('template[data-tpl="desktop"]') };
    const store = window.WMQuiz.createStore(config);
    const wide = window.matchMedia('(min-width: 1024px)');
    let layout = null;
    let scene = null;
    let lock = null;
    // The buy box: kept by reference (it leaves the page with the slot), opened on the quiz's pick once per
    // recommendation, so a shopper's own changes in it survive going back a step and returning.
    const park = page.querySelector('[data-wmq-park]');
    const boxEl = page.querySelector('[data-wmq-box]');
    let boxKey = null, rendering = false, boxWired = false;
    // auto: the box still holds the quiz's color split, so a new size keeps the shopper's pattern (the product
    // page box would grow or trim one color). Off once the shopper changes the colors themselves.
    let auto = { on: false, want: 0, fit: null };
    function split(n) {
      const s = store.state, alloc = {};
      window.WMQuiz.cartLines(n, s.mix, s.pattern, config.variants).forEach((i) => { alloc[i.id] = i.quantity; });
      return alloc;
    }
    const same = (a, b) => JSON.stringify(Object.keys(a).sort().map((k) => [k, a[k]])) === JSON.stringify(Object.keys(b).sort().map((k) => [k, b[k]]));
    function held() { const a = {}; (window.WMQBox.items() || []).forEach((i) => { a[i.id] = i.quantity; }); return a; }
    // The shopper's pick survives a reload (signup fallback, refresh) for the same quiz answers.
    const BOX_KEY = 'wm-quiz-box-v1';
    function saveBox() {
      try { sessionStorage.setItem(BOX_KEY, JSON.stringify({ key: boxKey, want: window.WMQBox.want(), alloc: held(), auto: auto.on, open: colorsOpen })); } catch (e) { /* storage off */ }
    }
    function boxChanged() {
      const box = window.WMQBox, w = box.want();
      // A new size re-splits the quiz colors in place (cards are not rebuilt, so focus stays on the stepper).
      if (auto.on && w !== auto.want) { auto.want = w; box.realloc(split(w)); return; }
      auto.want = w;
      if (auto.on && !same(held(), split(w))) auto.on = false;
      saveBox();
      if (!rendering) render();
    }
    function prefillBox(view) {
      const box = boxOn(config), s = store.state;
      if (!box || s.step !== 15) return;
      const avail = (config.variants || []).map((v) => (v.available ? 1 : 0)).join('');
      const key = [view.rec, s.mix.join('+'), s.pattern, view.fitsLabel, avail].join('|');
      if (key === boxKey) return;
      const first = boxKey === null;
      boxKey = key;
      const fit = { tiles: view.rec, label: view.fitsLabel };
      let saved = null;
      if (first) { try { saved = JSON.parse(sessionStorage.getItem(BOX_KEY) || 'null'); } catch (e) { /* ignore */ } }
      if (saved && saved.key === key && saved.want > 0) {
        auto = { on: !!saved.auto, want: saved.want, fit };
        colorsOpen = !!saved.open;
        box.set({ tiles: saved.want, alloc: saved.alloc || {}, fit, keepEmpty: true });
      } else {
        const alloc = split(view.rec);
        auto = { on: true, want: view.rec, fit };
        // Both quiz colors sold out: open the colors and let the shopper choose (no substitute color).
        colorsOpen = !Object.keys(alloc).length;
        box.set({ tiles: view.rec, alloc, fit, keepEmpty: true });
      }
      saveBox();
    }
    function heldNames() {
      return (window.WMQBox.items() || []).slice().sort((a, b) => b.quantity - a.quantity)
        .map((i) => ((config.variants || []).find((v) => v.id === i.id) || {}).color).filter(Boolean);
    }
    function colorText() {
      const names = heldNames();
      const pat = auto.on ? { checker: 'checkerboard', stripes: 'stripes' }[store.state.pattern] : '';
      const list = names.length > 2 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names.join(' and ');
      return list + (names.length > 1 && pat ? ', ' + pat : '');
    }
    // The bundle step's copy follows what the box holds, not what the quiz picked.
    function boxView(view) {
      const s = store.state;
      view.mixLabel = colorText() || view.mixLabel;
      if (auto.on && !s.cartError && !s.cartBusy) {
        const note = soldOutNote(s, view.rec, config);
        if (note) view.ctaFoot = note;
      }
    }
    // The quiz already asked for colors, so the box's color section starts folded into one line with a
    // Change link that opens it in place (Mkeo, 26 Oct 2026: "picking the colour twice").
    let colorsOpen = false;
    const colorLine = document.createElement('div');
    colorLine.className = 'wmq-colors';
    colorLine.innerHTML = '<span class="wmq-colors__dots"></span><span class="wmq-colors__txt"></span><button type="button" class="wmq-colors__btn" aria-expanded="false">Change</button>';
    colorLine.querySelector('button').addEventListener('click', (e) => {
      e.preventDefault(); colorsOpen = true; saveBox(); render();
      // The button hides once the colors open: move focus to the first color control.
      const step = boxEl.querySelectorAll(':scope > .wm-step')[1];
      const target = step && step.querySelector('button:not([disabled]), input:not([disabled])');
      if (target) target.focus();
    });
    function drawColorLine(view) {
      if (!boxEl || !window.WMQBox) return;
      const second = boxEl.querySelectorAll(':scope > .wm-step')[1];
      if (second && colorLine.nextSibling !== second) boxEl.insertBefore(colorLine, second);
      boxEl.classList.toggle('wmq-open', colorsOpen);
      colorLine.querySelector('button').setAttribute('aria-expanded', colorsOpen ? 'true' : 'false');
      const hex = {}; (view.swatches || []).forEach((w) => { hex[w.label] = w.hex; });
      const names = heldNames();
      colorLine.querySelector('.wmq-colors__txt').textContent = 'Your colors: ' + colorText();
      colorLine.querySelector('.wmq-colors__dots').innerHTML = names.map((n) => '<i style="background:' + (hex[n] || '#ccc') + '"></i>').join('');
    }
    function placeBox() {
      if (!boxEl || !park) return;
      const slot = host.querySelector('[data-wm-buybox-slot]');
      if (slot) { if (boxEl.parentNode !== slot) slot.appendChild(boxEl); }
      else if (boxEl.parentNode !== park) park.appendChild(boxEl);
    }
    function wireBox() {
      if (boxWired || !boxOn(config)) return;
      boxWired = true;
      window.WMQBox.onChange(boxChanged);
      render();
    }
    const hooks = [storeHook].concat(window.WMQuiz.uiHooks || []);

    try { const saved = JSON.parse(sessionStorage.getItem('wm-quiz-v1') || 'null'); if (saved && typeof saved.step === 'number') store.setState(Object.assign(saved, { toast: '', webglFail: false, cartBusy: false, cartError: '' })); } catch (e) { /* storage off: start fresh */ }

    function canvasRef(el) {
      if (scene || !window.WMQuiz.scene) return;
      scene = window.WMQuiz.scene(el, store);
    }
    function render() {
      rendering = true;
      try { draw(); } finally { rendering = false; }
    }
    function draw() {
      const want = wide.matches ? 'desktop' : 'mobile';
      if (want !== layout) {
        if (scene) { scene.dispose(); scene = null; }
        host.innerHTML = '';
        layout = want;
      }
      const view = store.view();
      prefillBox(view);
      view.canvasRef = canvasRef;
      hooks.forEach((h) => h(view, store, config));
      if (store.state.step === 15 && boxOn(config) && boxKey !== null) boxView(view);
      // Phones: the room fills what the text leaves. Within one step it may shrink once to fit new
      // text but never grows back, so it holds one size while the shopper picks (Mkeo, 25 Oct 2026).
      const step = store.state.step;
      view.sceneMin = 'min(120px, 14dvh)';
      // Colors step on phones: the room is the point (seeing the colors at home), so the whole page
      // scrolls there with a big room on top and the button at the end, not pinned (Mkeo, 25 Oct 2026).
      // The bundle step with the buy box is long too: same scrolling page, add-to-cart sticky (section CSS).
      const scrollPage = layout === 'mobile' && (step === 11 || (step === 15 && !!boxOn(config)));
      if (scrollPage !== host.classList.contains('wmq-scroll-page')) {
        host.classList.toggle('wmq-scroll-page', scrollPage);
        if (host.firstElementChild) host.firstElementChild.scrollTop = 0;
      }
      if (lock && lock.step === step && lock.layout === layout) view.sceneH = Math.min(parseFloat(view.sceneH) || lock.h, lock.h) + 'px';
      const refs = [];
      const fresh = children(tpls[layout].content, view, refs);
      morphChildren(host, fresh);
      placeBox();
      if (step === 15) drawColorLine(view);
      const box = host.querySelector('[data-wm-scene]');
      if (box) {
        const h = box.getBoundingClientRect().height;
        if (h > 0) lock = { step, layout, h: lock && lock.step === step && lock.layout === layout ? Math.min(lock.h, h) : h };
      }
      refs.forEach(([el, fn]) => { if (el.isConnected) fn(el); });
    }
    host.addEventListener('click', (e) => {
      const cta = e.target.closest && e.target.closest('[data-wm-cta]');
      if (cta) { e.preventDefault(); addToCart(store, config); return; }
      let t = e.target;
      while (t && t !== host) { if (t._wm && t._wm.click) { if (t.tagName === 'A' || t.tagName === 'BUTTON') e.preventDefault(); t._wm.click(e); return; } t = t.parentNode; }
    });
    const onInput = (e) => { const t = e.target; if (t._wm && t._wm.input) t._wm.input(e); };
    host.addEventListener('input', onInput);
    let lastStep = store.state.step;
    store.subscribe((s) => {
      if (s.step !== lastStep) { lastStep = s.step; track('quiz_step', { step: s.step }); }
      try { sessionStorage.setItem('wm-quiz-v1', JSON.stringify(Object.assign({}, s, { toast: '', cartBusy: false, cartError: '' }))); } catch (e) { /* ignore */ }
      render();
    });
    wide.addEventListener('change', render);
    window.addEventListener('resize', () => { lock = null; render(); });
    window.addEventListener('pageshow', (e) => {
      if (e.persisted && store.state.cartBusy) { if (boxOn(config)) window.WMQBox.setBusy(false); store.setState({ cartBusy: false }); }
    });
    window.addEventListener('wmq:box-ready', wireBox);
    const result = page.querySelector('[data-wm-signup-result]');
    if (result) {
      signupResult(result.getAttribute('data-wm-signup-result'));
      try { history.replaceState(null, '', location.pathname); } catch (e) { /* ignore */ }
    }
    render();
    wireBox();
    track('quiz_step', { step: store.state.step });
    return { store, render, config };
  }

  function boot() {
    document.querySelectorAll('[data-wm-quiz] [data-tpl-host]').forEach((host) => {
      if (host._wmMounted) return;
      host._wmMounted = true;
      window.WMQuiz.app = mount(host);
    });
  }
  window.WMQuiz.signupResult = signupResult;
  window.WMQuiz.navigate = (url) => { window.location.href = url; };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
